import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {update} from "../../../app/setters/update.js";

export const usePowiazKontoZProfilem = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => update(`profile/polacz`, data),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`profile_konta_polaczone`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
    });
};
